import React, {useEffect} from 'react';
import classNames from 'classnames';
import parse from 'html-react-parser';
import Image from '../Image';
import SineWave from '../../utils/sine-wave';
import RenderStaticHTML from '../RenderStaticHTML';

const ns = `hero`;

const Hero = props => {
	const {
		location,
		pageType,
		heroTitle,
		heroDescription,
		heroImage,
		bullets,
		heroEnableWave,
		heroFontIsDark,
		heroDetails: {
			title,
			description,
			heroEyebrow,
			backgroundColor,
			image,
			enableWave,
		},
		icon,
		isH1 = true,
	} = props;

	const rootClassnames = classNames({
		[`${ ns }`]: true,
		[`${ ns }--type-${ pageType }`]: pageType,
		[`${ ns }--bg-${ backgroundColor }`]: backgroundColor,
		[`${ ns }--color-white`]: !heroFontIsDark,
		[`${ ns }--wave-enabled`]: enableWave || heroEnableWave,
	});

	useEffect(() => {
		if (enableWave || heroEnableWave) {
			const heroWaveCallery = new SineWave('hero-wave', 'hero-wave-canvas');
			heroWaveCallery.init();
		}
	}, [location]);

	return (
		<div className={`${ rootClassnames }`}>
			<div className={`${ ns }__media`}>
				<Image dataMedia {...image || heroImage} />
			</div>
			<div className={`${ ns }__container`}>
				<div className="container">
					<div className={`${ ns }__content ${(description || heroDescription) ? '' : 'center'}`}>
						{heroEyebrow && (
							<p className={`${ ns }__eyebrow`}>{heroEyebrow}</p>
						)}
						{isH1 ? (
							<h1 className={`${ ns }__title h2`}>
								{title || heroTitle}
							</h1>
						) : (
							<h2 className={`${ ns }__title h2`}>
								{title || heroTitle}
							</h2>
						)}
						{(description || heroDescription) && (
							<div className={`${ ns }__description`}>
								{parse(description || heroDescription)}
							</div>
						)}
						{bullets && (
							<ul className={`${ ns }__bullets`}>
								{bullets.map(bullet => {
									return (
										<li className={`${ ns }__bullet`} key={bullet}>
											{bullet}
										</li>
									);
								})}
							</ul>
						)}
					</div>
					{icon && (
						<RenderStaticHTML className={`${ ns }__category-icon`} html={icon} />
					)}
				</div>
			</div>
			{(enableWave || heroEnableWave) && (
				<div
					id="hero-wave"
					className={`${ ns }__sinewave }`}
				>
					<canvas id="hero-wave-canvas" />
				</div>
			)}
		</div>
	);
};

Hero.defaultProps = {
	heroDetails: {
		backgroundColor: 'Navy',
	},
};

export default Hero;
